// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TradingCentralExtLink } from './TradingCentralExtLink';
export class ITChartAdvancedExtLink extends TradingCentralExtLink {
    constructor() {
        super(...arguments);
        this.itAdvancedPrivateKey = '';
    }
    // Override method
    update(brandingTool, extLinkMessage) {
        var _a;
        super.update(brandingTool, extLinkMessage);
        if (brandingTool) {
            this.itAdvancedPrivateKey = (_a = brandingTool.privateKey) !== null && _a !== void 0 ? _a : this.itAdvancedPrivateKey;
        }
    }
}
